import React, { useState } from 'react';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import './App.css';
import HomePage from './HomePage';
import SubscriberSignUpPage from './SubscriberSignUpPage';
import OptOutPage from './OptOutPage';
import FiftyThousandPage from './FiftyThousandPage';
import WordChaserPage from './WordChaserPage';
import PageNotFoundPage from './PageNotFoundPage';
import ScrollToTop from './ScrollToTop';

//let serveraddress = "http://localhost";
//let serveraddress = "https://what.pizza";

const App = ( ) => {

  const startingFormState = {
    "displayname": "",
    "youtubechannelurl": "",
    "wanttobeinvideo": false,
    "submitted": false,
    "captchatoken": ""
   };

  const [formState, setFormState] = useState(startingFormState);


  const changeFormState = (newValue, field) => {
   setFormState(prevState  => {
     return {
       ...prevState,
       [field]: newValue,
     };
   });
  };
  
  return (
    <Router>
    <ScrollToTop />
    <Switch>
      <Route path={["/word", "/wordchaser"]} exact>
        <div className="App" style={{backgroundImage: `url("/webpagebackground2.jgg")`, padding: "0px", height: "100%", overflowX: "hidden", overflowY: "hidden"}}>
          <div style={{padding: "12px 0px 0px 0px", height: "100%"}}>
            <WordChaserPage />
          </div>
        </div>
      </Route>
      <Route>
        <main className="App" style={{backgroundImage: `url("/webpagebackground2.jpg")`, padding: "0px"}}>
          <div style={{padding: "12px 0px 0px 0px"}}>
            <Switch>
              <Route path={[""]} exact>
                <HomePage formState={formState} changeFormState={changeFormState} />
              </Route>
              <Route path={["/subscribersignup", "/signup"]} exact>
                <SubscriberSignUpPage formState={formState} changeFormState={changeFormState} />
              </Route>
              <Route path={["/opt-out"]} exact>
                <OptOutPage formState={formState} changeFormState={changeFormState} />
              </Route>
              <Route path={["/50k"]} exact>
                <FiftyThousandPage />
              </Route>
              {/*
              <Route path={["/worddesktop"]} exact>
                <WordChaserPage />
              </Route>*/}
              <Route>
                <PageNotFoundPage />
              </Route>
            </Switch>
              <br className={`unselectable`}/>
              <br className={`unselectable`}/>
              <br className={`unselectable`}/>
              <br className={`unselectable`}/>
              <br className={`unselectable`}/>
            <footer className={"unselectable"}><div>KhalidSMShahin</div></footer>
            { /* <div className={"footerClass unselectable"}><div style={{width: "100%"}}>KhalidSMShahin</div><div></div></div> */ }
          </div>
        </main>
      </Route>
    </Switch>
    </Router>
  );
};


export default App;
